import { cn } from '@mntn-dev/ui-utilities'
import { Form, type FormProps } from '../../form/form.tsx'

export type FormModalFormProps = FormProps
export const FormModalForm = ({
  children,
  className,
  ...props
}: FormModalFormProps) => {
  return (
    <Form {...props} className={cn('gap-6 w-full', className)}>
      {children}
    </Form>
  )
}
